export default __webpack_public_path__ + "static/media/Herma.74fdb2ca.png";